import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtilsService } from '../../commons/http-uilis.service';
import { Observable, catchError, map, mergeMap } from 'rxjs';
import { JsonConvert } from 'json2typescript';
import { Paging } from '../../../model/paging/paging';
import { environment } from '../../../environment/environment';
import { keycloakLogout } from '../../../auth/keycloak.config';
import { BomComponent, BomComponentData, BomComponentDataArray } from '../../../model/bom-component/bom-component';


@Injectable({
    providedIn: 'root'
})
export class BomComponentService {
    private _url: string = `${environment.baseAPIURL}/settings`;
    constructor(private _http: HttpClient, private _httpUtils: HttpUtilsService) { }

    GETPaginatedBomComponents(paging:Paging): Observable<BomComponent>  | any{
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}/components${this.buildQueryString(paging)}`,{ headers: httpHeaders, withCredentials:true }).pipe(
                        map((res:any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: BomComponentDataArray = jsonConvert.deserializeObject(res, BomComponentDataArray);
                            if (response.success) {
                            	return response;
                            } else {
                            	this._httpUtils.handleError(response);
                                return;
                            }
                        }, catchError(err => {
                            if (err.status === 401) {
                                keycloakLogout({ redirectUri: window.location.origin });
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    GETComponentById(componentId:string): Observable<BomComponent>  | any{
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}/components/${componentId}`,{ headers: httpHeaders, withCredentials:true }).pipe(
                        map((res:any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: BomComponentData = jsonConvert.deserializeObject(res, BomComponentData);
                            if (response.success) {
                            	return response;
                            } else {
                            	this._httpUtils.handleError(response);
                                return;
                            }
                        }, catchError(err => {
                            if (err.status === 401) {
                                keycloakLogout({ redirectUri: window.location.origin });
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    PUTBomComponentStatus(componentId:string, body:BomComponent){
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.put(`${this._url}/components/${componentId}`, this.toUpdatePayload(body), { headers: httpHeaders, withCredentials:true }).pipe(
                        map((res:any) => {
                            return res;
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                keycloakLogout({ redirectUri: window.location.origin });
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    DELETEBomComponent(componentId:string){
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.delete(`${this._url}/components/${componentId}`, { headers: httpHeaders, withCredentials:true }).pipe(
                        map((res:any) => {
                            return res;
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                keycloakLogout({ redirectUri: window.location.origin });
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }   

    POSTBomComponent(body:BomComponent){
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.post(`${this._url}/components`, this.toCreatePayload(body), { headers: httpHeaders, withCredentials:true }).pipe(
                        map((res:any) => {
                            return res;
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                keycloakLogout({ redirectUri: window.location.origin });
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    private buildQueryString(paging: Paging): string {
        const params = new URLSearchParams({
            offset: String((paging.pageIndex - 1) * paging.pageSize),
            limit: String(paging.pageSize)
        });
        const sort = paging.sort.find((item) => item.value !== null);
        if (sort?.key) {
            params.set('sortBy', sort.key);
        }
        if (sort?.value === 'ascend') {
            params.set('sortOrder', 'asc');
        } else if (sort?.value === 'descend') {
            params.set('sortOrder', 'desc');
        }
        return `?${params.toString()}`;
    }

    private toCreatePayload(body: BomComponent) {
        return {
            code: body.code,
            name: body.name,
            category: body.category,
            description: body.description,
            active: body.active
        };
    }

    private toUpdatePayload(body: BomComponent) {
        return {
            name: body.name,
            category: body.category,
            description: body.description,
            active: body.active
        };
    }
}
